import React from 'react';
import Icon from '../../../components/AppIcon';

const TeamProfiles = () => {
  const teamMembers = [
    {
      id: 1,
      name: "Michael Rodriguez",
      position: "Chief Technology Officer",
      experience: "12+ years",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop",
      certifications: ["CFOT", "FOI", "NECA"],
      specialties: ["Enterprise Networking", "Data Center Infrastructure", "Network Architecture"],
      description: "Michael leads our technical strategy and oversees complex enterprise installations. His expertise in network architecture ensures optimal performance for mission-critical systems."
    },
    {
      id: 2,
      name: "Sarah Chen",
      position: "Senior Installation Manager",
      experience: "10+ years",
      image: "https://img.freepik.com/premium-photo/professional-female-manager-walking-modern-office-district_35674-13442.jpg?w=400&h=400&fit=crop",
      certifications: ["CFOT", "OSHA 30", "CompTIA Network+"],
      specialties: ["Industrial Installations", "Safety Compliance", "Project Management"],
      description: "Sarah manages our largest installations with a focus on safety and minimal business disruption. Her industrial expertise covers manufacturing and healthcare facilities."
    },
    {
      id: 3,
      name: "David Thompson",
      position: "Regulatory Compliance Director",
      experience: "15+ years",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
      certifications: ["BICSI", "RCDD", "DCCA"],
      specialties: ["Regulatory Compliance", "Code Requirements", "Documentation"],
      description: "David ensures all installations meet local, state, and federal requirements. His regulatory expertise streamlines permitting and inspection processes."
    },
    {
      id: 4,
      name: "Jennifer Park",
      position: "Customer Success Manager",
      experience: "8+ years",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop",
      certifications: ["PMP", "ITIL", "Customer Success"],
      specialties: ["Client Relations", "Post-Installation Support", "Training Programs"],
      description: "Jennifer manages client relationships from initial consultation through ongoing support. She ensures seamless project communication and successful outcomes."
    }
  ];

  return (
    <section className="py-16 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-text-primary mb-4">
            Expert Team Profiles
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Our certified professionals bring decades of combined experience in telecommunications infrastructure, ensuring your project is handled by industry experts.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembers?.map((member) => (
            <div key={member?.id} className="bg-white rounded-xl shadow-brand-moderate hover:shadow-brand-strong transition-all duration-300 overflow-hidden group">
              <div className="aspect-square overflow-hidden">
                <img
                  src={member?.image}
                  alt={member?.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              
              <div className="p-6 space-y-4">
                <div>
                  <h3 className="text-xl font-semibold text-text-primary">{member?.name}</h3>
                  <p className="text-primary font-medium">{member?.position}</p>
                  <p className="text-sm text-text-secondary">{member?.experience}</p>
                </div>
                
                <p className="text-sm text-text-secondary leading-relaxed">
                  {member?.description}
                </p>
                
                <div className="space-y-3">
                  <div>
                    <h4 className="text-sm font-semibold text-text-primary mb-2">Certifications</h4>
                    <div className="flex flex-wrap gap-1">
                      {member?.certifications?.map((cert, index) => (
                        <span
                          key={index}
                          className="px-2 py-1 bg-primary/10 text-primary text-xs rounded-md"
                        >
                          {cert}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <div>
                    <h4 className="text-sm font-semibold text-text-primary mb-2">Specialties</h4>
                    <div className="space-y-1">
                      {member?.specialties?.map((specialty, index) => (
                        <div key={index} className="flex items-center space-x-2">
                          <Icon name="CheckCircle" size={12} className="text-accent" />
                          <span className="text-xs text-text-secondary">{specialty}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamProfiles;